<template>
<div class="chapter">
<div class="inner_page">
<p class="imagep"><span><a id="page_5"><img alt="" height="24" src="images/star.jpg" width="104"/></a></span></p><a id="page_5">
</a><p class="ptnum" id="rpt01"><a id="page_5"><span></span></a><a href="#/Contents#pt01">PART 1</a></p>
<p class="pttitle"><span><a href="#/Contents#pt01">OVERVIEW</a></span></p>
<p class="imagepa"><span><img alt="" height="24" src="images/ptstar.jpg" width="221"/></span></p>
<p class="imagepb"><span><img alt="" height="350" src="images/pt.jpg" width="355"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?59b469a2